import { createContext, useState, useContext, useMemo, useCallback } from 'react';


const BackOfficeContext = createContext();

const BackOfficeProvider = ({ children }) => {

    const [selectedBackOffice, setSelectedBackOffice] = useState('groups');

    const handleSelectedBackOffice = useCallback((backOffice) => {
        setSelectedBackOffice(backOffice);
    }, []);

    const [groups, setGroups] = useState([])

    const handleSetGroups = useCallback((groups) => {
        setGroups(groups);
    }, []);

    const [railways, setRailways] = useState([])

    const handleSetRailways = useCallback((railways) => {
        setRailways(railways);
    }, []);

    const [selectedGroup, setSelectedGroup] = useState(null)
    
    const handleSelectedGroup = useCallback((group) => {
        setSelectedGroup(group)
    }, []);
    
    const [userModalOpen, setUserModalOpen] = useState(false)

    // Quem está sendo editado. null = o modal está no modo "novo usuário".
    // Fica aqui, junto do controle de abertura, para os dois nunca saírem de
    // sincronia (abrir para criar com o usuário anterior ainda carregado
    // mostraria os dados dele no formulário de criação).
    const [editingUser, setEditingUser] = useState(null)

    const handerUserModalOpen = useCallback(() => {
        setEditingUser(null)
        setUserModalOpen(true)
    }, []);

    const handlerUserModalOpenForEdit = useCallback((user) => {
        setEditingUser(user)
        setUserModalOpen(true)
    }, []);

    const handlerUserModalClose = useCallback(() => {
        setUserModalOpen(false)
        setEditingUser(null)
    }, []);

    const [updateUserTable, setUpdateUserTable] = useState(false)

    const handlerUpdateUserTable = useCallback(() => {
        setUpdateUserTable((prev) => !prev)
    }, []);
    
    const value = useMemo(() => ({

        selectedGroup,
        handleSelectedGroup,

        groups,
        handleSetGroups,

        railways,
        handleSetRailways,

        selectedBackOffice,
        handleSelectedBackOffice,

        userModalOpen,
        handerUserModalOpen,
        handlerUserModalOpenForEdit,
        handlerUserModalClose,

        editingUser,

        updateUserTable,
        handlerUpdateUserTable
        
    }), [
        selectedGroup,
        groups,
        railways,
        selectedBackOffice,
        userModalOpen,
        updateUserTable,
        handleSelectedGroup,
        handleSetGroups,
        handleSetRailways,
        handleSelectedBackOffice,
        handerUserModalOpen,
        handlerUserModalClose,
        handlerUpdateUserTable,
        // Sem `editingUser` aqui o useMemo não recalcula quando ele muda: o
        // provider seguiria entregando o valor antigo e o modal de edição
        // abriria sem o usuário selecionado.
        editingUser,
        handlerUserModalOpenForEdit
    ])

    return (
        <BackOfficeContext.Provider value={value}>
            {children}
        </BackOfficeContext.Provider>
    )
}

// Custom hook to use the Farol context
const useBackOffice = () => {
    const context = useContext(BackOfficeContext);
    if (context === undefined) {
        throw new Error('useBackOffice must be used within a BackOfficeProvider');
    }
    return context;
};

export { BackOfficeContext, BackOfficeProvider, useBackOffice };